// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3h1ev","amount":"Amount_amount__3fbLG","tip":"Amount_tip__3M638","tipHeader":"Amount_tipHeader__3KLt8","tipsWrap":"Amount_tipsWrap__1QPdg"};